import { useEffect, useState } from "react";

const useCheckboxList = () => {
  const [activeCheckboxes, setActiveCheckboxes] = useState([]);
  const [activeChildrens, setActiveChildrens] = useState([]);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    revalidate();
  }, [activeCheckboxes.length]);

  const revalidate = () => {
    setIsValid(activeCheckboxes.length !== 0);
  };

  const toggleMainCheckbox = (id, value) => {
    const oldActive = !!activeCheckboxes.find((c) => c.id === id);
    if (oldActive) {
      setActiveCheckboxes((prev) => prev.filter((c) => c.id !== id));
      setActiveChildrens((prev) => prev.filter((c) => c.parentId !== id));
    } else {
      setActiveCheckboxes((prev) => [...prev, { id, value }]);
    }
  };

  const toggleSubCheckbox = (id, parentId, value, parentValue) => {
    const oldActive = !!activeChildrens.find((c) => c.id === id);
    const parendOldActive = !!activeCheckboxes.find((p) => p.id === parentId);

    if (oldActive) {
      setActiveChildrens((prev) => prev.filter((c) => c.id !== id));
    } else {
      setActiveChildrens((prev) => [...prev, { id, parentId, value }]);
      if (!parendOldActive) {
        setActiveCheckboxes((prev) => [
          ...prev,
          { id: parentId, value: parentValue },
        ]);
      }
    }
  };

  const replaceAll = (newActiveCheckboxes, newActiveChildrens) => {
    if (newActiveCheckboxes) {
      setActiveCheckboxes(newActiveCheckboxes);
    }
    if (newActiveChildrens) {
      setActiveChildrens(newActiveChildrens);
    }
  };

  const getActiveCheckboxList = () =>
    activeCheckboxes.map((i) => ({
      value: i.value,
      childrens: activeChildrens
        .filter((c) => c.parentId === i.id)
        .map((c) => ({
          value: c.value,
        })),
    }));

  return {
    activeCheckboxes,
    activeChildrens,
    toggleMainCheckbox,
    toggleSubCheckbox,
    getActiveCheckboxList,
    replaceAll,
    isValid,
  };
};

export default useCheckboxList;
